module.exports = __webpack_public_path__ + "img/kdb_icon.cf006a67.jpg";